






































































































































import { defineComponent } from '@vue/composition-api'
import {
  useCategories,
  categoryGetters,
  useCustomer,
  customerGetters,
  useUiState,
} from '@aspenware-library/composables'
import type { Category, AxWindow } from '@aspenware-library/types'
import CloseButton from './CloseButton.vue'
import { Route } from 'vue-router'
import { mapGetters } from 'vuex'

const { isNavSidebarOpen } = useUiState()
const { categories } = useCategories()
const { customer } = useCustomer()

type Link = {
  text: string
  href: string
}

export default defineComponent({
  name: 'NavigationSidebar',
  components: {
    CloseButton,
  },
  data() {
    return {
      categoryGetters,
      activeCategory: undefined as Category | undefined,
      loginLink: undefined as Link | undefined,
      logoutLink: undefined as Link | undefined,
      brandSite: undefined as Link | undefined,
      shopSite: undefined as Link | undefined,
      showMiniLogo: true,
      showUserAvatar: false,
      myAccountSubLabel: '',
      finishImpersonationLabel: '',
    }
  },
  computed: {
    isCustomerImpersonated() {
      return customerGetters.isCustomerImpersonated(customer.value)
    },

    orderedCategories() {
      // explicit cast because build isn't inferring type
      const cats = (this.activeCategory as Category | undefined)?.SubCategories || categories.value
      return categoryGetters.getCategories(cats)
    },
    customerAvatar() {
      return customerGetters.getAvatar(customer.value)
    },
    customerInitials() {
      return customerGetters.getInitials(customer.value)
    },
    showHubLink() {
      return !customerGetters.isGuest(customer.value) && !this.activeCategory
    },
    showLogin() {
      return customerGetters.isGuest(customer.value) && !this.activeCategory
    },
    isAdmin() {
      return customerGetters.isAdmin(customer.value)
    },
    myAccountLabel() {
      return (window as AxWindow)?.storeSettings?.Labels.Menu.AccountButtonTitle?.replace(
        '{0}',
        customerGetters.getFirstName(customer.value) || ''
      )
    },
    isOpen: {
      get() {
        return isNavSidebarOpen.value
      },
      set(val: boolean) {
        isNavSidebarOpen.value = val
      },
    },

    isOnCatalogPage() {
      return !categoryGetters.shouldUseExternalRoute(this.$route.path)
    },

    /*
      show categories when on catalog page and ready for category navigation or always if not on a catalog page
     */
    showCategories() {
      return (this.isOnCatalogPage && this.readyForCategoryNavigation) || true
    },

    ...mapGetters({
      readyForCategoryNavigation: 'products/readyForCategoryNavigation',
    }),
  },
  mounted() {
    // configure links
    const storeSettings = (window as AxWindow)?.storeSettings!
    this.loginLink = {
      href: `/login?returnUrl=${window.location.href}`,
      text: storeSettings.Labels.Menu.Login,
    }
    this.logoutLink = {
      href: '/logout',
      text: storeSettings.Labels.Menu.Logout,
    }
    this.brandSite = {
      href: storeSettings.Store.BrandUrl,
      text: storeSettings.Labels.Menu.BrandSiteLinkText,
    }
    this.shopSite = {
      href: '/',
      text: storeSettings.Labels.Menu.ShopLinkText,
    }
    this.myAccountSubLabel = storeSettings.Labels.Menu.AccountButtonSubtitle
    this.finishImpersonationLabel = storeSettings.Labels.Menu.FinishImpersonation
  },
  methods: {
    getCategoryLink(category: Category) {
      return categoryGetters.getCategoryLink({
        category,
      })
    },
    closeSidebar() {
      isNavSidebarOpen.value = false
      this.activeCategory = undefined
    },
    handleNavDrawerInput(val: boolean) {
      if (!val) {
        this.closeSidebar()
      }
    },
    changeLogoDisplay() {
      this.showMiniLogo = false
    },
  },
  watch: {
    customerAvatar(newVal) {
      if (!newVal) {
        this.showUserAvatar = false
        return
      }
      fetch(newVal).then((res) => {
        this.showUserAvatar = res.status === 200
      })
    },
    activeCategory(newVal) {
      if (newVal) {
        setTimeout(() => {
          ;(document.getElementById('nav-sidebar__back') as HTMLElement)?.focus()
        })
      }
    },
    $route(newVal: Route) {
      // Update the login link's Return URL when the path changes
      if (this.loginLink) {
        this.loginLink.href = `/login?returnUrl=${window.location.origin + newVal.fullPath}`
      }
    },
  },
})
